import React, { useContext } from "react";
import { BookContext } from '../../context/books';
import { Link } from "react-router-dom";
import "./RevistasList.css";
import coverImg from "../../images/cover_not_found.jpg";
import config from '../../aws-exports';

const {
    aws_user_files_s3_bucket_region: region,
    aws_user_files_s3_bucket: bucket
} = config

const Revista = (revista) => {
    const { idioma } = useContext(BookContext);
    switch (idioma) {
      case "español":
    return (
        <div className="revistas-item flex flex-column flex-sb">
          <Link to = {`/revista/id/${revista.id}`} {...revista}>
            <div className="revistas-item-img">
                <img src = {revista.portada ? `https://${bucket}.s3.${region}.amazonaws.com/imgrevistas/${revista.portada}` : coverImg} alt = "cover" />
            </div>
          </Link>
            <div className="revistas-item-info text-center">
                <Link to = {`/revista/id/${revista.id}`} {...revista}>
                    <div className="revistas-inte-info-item title fw-7 fs-18">
                        <span>{revista.titulo}</span>
                    </div>
                </Link>

                <div className="revistas-inte-info-item author fs-15">
                    <span className="text-capitalized fw-7">Autor: </span>
                    <span>{revista.autor}</span>
                </div>
                 <div className="revistas-inte-info-item publish-year fs-15">
                    <span className="text-capitalized fw-7">Fecha de edición: </span>
                    <span>{revista.anoedicion}</span>
                </div>
                <Link to = {`/revista/id/${revista.id}`} {...revista}>
                <div className="revistas-inte-info-item author fw-3 fs-09">
                <span className="fw-3 fs-09">(Click para mas datos)</span>
                </div>
                </Link>
            </div>
        </div>
    )
    case "english":
        return (
            <div className="revistas-item flex flex-column flex-sb">
              <Link to = {`/revista/id/${revista.id}`} {...revista}>
                <div className="revistas-item-img">
                    <img src = {revista.portada ? `https://${bucket}.s3.${region}.amazonaws.com/imgrevistas/${revista.portada}` : coverImg} alt = "cover" />
                </div>
              </Link>
                <div className="revistas-item-info text-center">
                    <Link to = {`/revista/id/${revista.id}`} {...revista}>
                        <div className="revistas-inte-info-item title fw-7 fs-18">
                            <span>{revista.titulo}</span>
                        </div>
                    </Link>
    
                    <div className="revistas-inte-info-item author fs-15">
                        <span className="text-capitalized fw-7">Author: </span>
                        <span>{revista.autor}</span>
                    </div>
                    <div className="revistas-inte-info-item publish-year fs-15">
                        <span className="text-capitalized fw-7">Edition's date: </span>
                        <span>{revista.anoedicion}</span>
                    </div>
                    <Link to = {`/revista/id/${revista.id}`} {...revista}>
                    <div className="revistas-inte-info-item author fw-3 fs-09">
                    <span className="fw-3 fs-09">(Click for more info)</span>
                    </div>
                    </Link>
                </div>
            </div>
        )
        default:
            break;
}
}

export default Revista;